import { useQuery } from "@tanstack/react-query";
import { fetchUserIPApi } from "@/API/fetchUserIPApi";

export const useFetchUserIP = () => {
  return useQuery<string, Error>({
    queryKey: ["userIP"],
    queryFn: fetchUserIPApi,
    staleTime: Infinity, //As the ip does't change
  });
};
